import { Routes, Route } from 'react-router-dom'
import Layout from './components/layout/Layout'
import ProtectedRoute from './components/ProtectedRoute'
import Home from './pages/Home'
import About from './pages/About'
import Dashboard from './pages/Dashboard'
import Contact from './pages/Contact'
import Login from './pages/Login'
import Dashboardv2 from './pages/Dashboardv2'
import EventsPage from './pages/Events'
import PlacesPage from './pages/Places'
import ManagePlaces from './pages/ManagePlaces'
import ManageEvents from './pages/ManageEvents'
import ManageSurveys from './pages/ManageSurveys'
import ManageMilestones from './pages/ManageMilestones'
import ManageFAQs from './pages/ManageFAQs'
import ManagePlanDetails from './pages/ManagePlanDetails'
import AdminFeedback from './pages/AdminFeedback'

function App() {
  return (
    <Layout>
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/about" element={<About />} />
        <Route path="/places" element={<PlacesPage />} />
        <Route
          path="/manage-places"
          element={
            <ProtectedRoute>
              <ManagePlaces />
            </ProtectedRoute>
          }
        />
        <Route path="/events" element={<EventsPage />} />
        <Route
          path="/manage-events"
          element={
            <ProtectedRoute>
              <ManageEvents />
            </ProtectedRoute>
          }
        />
        <Route
          path="/manage-surveys"
          element={
            <ProtectedRoute>
              <ManageSurveys />
            </ProtectedRoute>
          }
        />
        <Route
          path="/manage-milestones"
          element={
            <ProtectedRoute>
              <ManageMilestones />
            </ProtectedRoute>
          }
        />
        <Route
          path="/manage-faqs"
          element={
            <ProtectedRoute>
              <ManageFAQs />
            </ProtectedRoute>
          }
        />
        <Route
          path="/manage-plan-details"
          element={
            <ProtectedRoute>
              <ManagePlanDetails />
            </ProtectedRoute>
          }
        />
        <Route path="/contact" element={<Contact />} />
        <Route path="/projects" element={<Dashboard />} />
        <Route path="/dashboardv2" element={<Dashboardv2 />} />
        <Route path="/login" element={<Login />} />
        <Route
          path="/admin/feedback"
          element={
            <ProtectedRoute>
              <AdminFeedback />
            </ProtectedRoute>
          }
        />
      </Routes>
    </Layout>
  )
}

export default App